var map = {
	"./Bank.sol": 1321,
	"./BankFactory.sol": 1322,
	"./CrosslinkShip.sol": 1323,
	"./CrosslinkShipFactory.sol": 1324,
	"./Dragon.sol": 1325,
	"./DragonFactory.sol": 1326,
	"./Encrypt.sol": 1327,
	"./EncryptFactory.sol": 1328,
	"./FakeFibonacciBank.sol": 1329,
	"./FakeFibonacciFactory.sol": 1330,
	"./Fomo4D.sol": 1331,
	"./Fomo4DFactory.sol": 1332,
	"./Freeshop.sol": 1333,
	"./FreeshopFactory.sol": 1334,
	"./Guard.sol": 1335,
	"./Instance.sol": 1336,
	"./InstanceFactory.sol": 1337,
	"./MorganStark.sol": 1338,
	"./MorganStarkFactory.sol": 1339,
	"./PaperScissorsStone.sol": 1340,
	"./PaperScissorsStoneFactory.sol": 1341,
	"./StrongBox.sol": 1342,
	"./StrongBoxFactory.sol": 1343,
	"./University.sol": 1344,
	"./UniversityFactory.sol": 1345,
	"./VentureCapital.sol": 1346,
	"./VentureCapitalFactory.sol": 1347,
	"./base/Level.sol": 1348
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;



//////////////////
// WEBPACK FOOTER
// ./contracts/levels ^\.\/.*$
// module id = 509
// module chunks = 0